import { createContext, useContext, useState, useEffect } from "react";

export const HospitalContext = createContext({
  hospitalData: null,
  setHospitalData: () => {}
});

export const HospitalProvider = ({ children, initialHospitalData }) => {
  // Try to get hospital data from localStorage first, then use initialHospitalData
  const getInitialHospitalData = () => {
    try {
      const stored = localStorage.getItem('hospital');
      if (stored) {
        return JSON.parse(stored);
      }
    } catch (error) {
      console.warn('Failed to parse stored hospital data:', error);
    }
    return initialHospitalData || null;
  };

  const [hospitalData, setHospitalData] = useState(getInitialHospitalData);

  // Update hospital data when initialHospitalData prop changes
  useEffect(() => {
    if (initialHospitalData) {
      setHospitalData(initialHospitalData);
    }
  }, [initialHospitalData]);

  // Persist hospital data to localStorage when it changes
  useEffect(() => {
    if (hospitalData) {
      localStorage.setItem('hospital', JSON.stringify(hospitalData));
    }
  }, [hospitalData]);

  // Debug logging for hospital data changes
  const setHospitalDataWithLogging = (data) => {

    setHospitalData(data);
  };

  return (
    <HospitalContext.Provider value={{ hospitalData, setHospitalData: setHospitalDataWithLogging }}>
      {children}
    </HospitalContext.Provider>
  );
};

export const useHospital = () => useContext(HospitalContext);
